import { UserLoginType } from "@/DTO";
import { Api } from "@/api";

export const NewCategory = (
  user: UserLoginType,
  name: string,
  parent_id?: string
) => {
  return new Promise<{}>((resolve, reject) => {
    const api = new Api({
      method: "post",
      path: `category`,
      header: {
        Authorization: "Bearer " + user?.accessToken,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: name,
        parent_id: parent_id
      })
    });
    return api
      .call()
      .then((data) => {
        return resolve({
          data
        });
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
